"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerZone = exports.BannerZoneSportType = exports.BannerZonePlatform = exports.BannerZoneLocation = void 0;
var constants_1 = require("./constants");
var constants_2 = require("@gin-betting/constants");
Object.defineProperty(exports, "BannerZoneLocation", { enumerable: true, get: function () { return constants_2.BannerZoneLocation; } });
Object.defineProperty(exports, "BannerZonePlatform", { enumerable: true, get: function () { return constants_2.BannerZonePlatform; } });
Object.defineProperty(exports, "BannerZoneSportType", { enumerable: true, get: function () { return constants_2.BannerZoneSportType; } });
var BannerZone;
(function (BannerZone) {
    BannerZone["ClassicTop"] = "classic_top";
    BannerZone["ClassicBottom"] = "classic_bottom";
    BannerZone["ClassicLeft"] = "classic_left";
    BannerZone["ClassicRight"] = "classic_right";
    BannerZone["EsportTop"] = "esport_top";
    BannerZone["EsportBottom"] = "esport_bottom";
    BannerZone["EsportLeft"] = "esport_left";
    BannerZone["EsportRight"] = "esport_right";
    BannerZone["ClassicEventsOfTheDay"] = "classic_events_of_the_day_slider";
    BannerZone["EsportEventsOfTheDay"] = "esport_events_of_the_day_slider";
    BannerZone["EsportTopSportEvents"] = "esport_top_sport_events";
    BannerZone["ClassicTopSportEvents"] = "classic_top_sport_events";
})(BannerZone = exports.BannerZone || (exports.BannerZone = {}));
//# sourceMappingURL=types.js.map